import { routes as home } from '../pages/home'
import { routes as yzxml } from '../pages/yzxml'
import { routes as dfes } from '../pages/dfes'
import { routes as users } from '../pages/users'
import { routes as contadores } from '../pages/contadores'
import { routes as config } from '../pages/config'
import { routes as configYzxml } from '../pages/config-yzxml'
import { routes as configEmitente } from '../pages/config-emitente'
import { routes as auth } from '../modules/auth'

export default [
  ...auth,
  ...home,
  ...yzxml,
  ...dfes,
  ...users,
  ...config,
  ...configYzxml,
  ...contadores,
  ...configEmitente,
]
